import $axios from './axios-instance';
import { global_error_handler } from './global-error-handler';
import { getApiBaseUrl } from './runtime-urls';

type MethodsRequestType = 'get' | 'post' | 'put' | 'delete';

export const requestHelper = async (
  url: string,
  method: MethodsRequestType,
  data: any = {},
  formData: string = '_default',
) => {
  //console.log('___loadOptions___', data)

  function isNotEmpty(value: any) {
    return value !== undefined && value !== null && value !== '';
  }

  let params = '?';

  if (formData !== '_default') {
    let tempFormData = new FormData();

    for (let key in data.values) {
      if (key === formData) {
        tempFormData.append(key, data.values[key][0]);
      } else {
        tempFormData.append(key, data.values[key]);
      }
    }

    return await $axios[method](getApiBaseUrl()!, tempFormData)
      .then((res: any) => {
        return res.data;
      })
      .catch((e: any) => {
        global_error_handler(e);
        throw e.response.data || 'Произошла ошибка 2';
      });
  }

  if (method === 'get') {
    [
      'skip',
      'searchValue',
      'take',
      'requireTotalCount',
      'requireGroupCount',
      'sort',
      'filter',
      'totalSummary',
      'group',
      'groupSummary',
    ].forEach(function (i) {
      if (i in data && isNotEmpty(data[i])) params += `${i}=${JSON.stringify(data[i])}&`;
    });
    params = params.slice(0, -1);

    return await $axios
      .get(`${url}${params}`, data.values)
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        global_error_handler(e);
        throw e.response.data || 'Произошла ошибка';
      });
  }

  return await $axios[method](url, data.values)
    .then((res: any) => {
      return res.data;
    })
    .catch((e: any) => {
      global_error_handler(e);
      throw e.response.datas || 'Произошла ошибка';
    });
};
